import { ModalBodyInputRadio } from '@ui/components/Modal/Body/Input/Radio'

import { ModalBodyInputSelect } from './SelectInput'

export const ModalBodyInput = {
  Radio: ModalBodyInputRadio,
  SelectInput: ModalBodyInputSelect,
}
